// ─────────────────────────────────────────────────────────────────────────────
// WARNING — READ BEFORE TOUCHING THIS FILE
//
// This key is NOT a secret and CANNOT be one — it ships inside the browser bundle,
// so anyone who opens dev tools or downloads the deployed JS can read it in seconds.
// It exists ONLY to keep public/env.js's non-sensitive runtime config (the API base
// URL, OAuth client ids, Turnstile site key, etc.) out of plaintext at rest,
// satisfying an audit requirement for "no plaintext config in a deployed file." It
// provides ZERO real confidentiality.
//
// This project decodes env.js SYNCHRONOUSLY (plain XOR + base64, not Web Crypto's
// async AES-GCM) on purpose — this very file's own `export const LANDING_URL = ...`
// and src/api/apiService.js's `const BASE_URL = ...` both capture env.X into a
// top-level const at module load time, before any async decrypt could ever resolve.
// Keep it synchronous or those captured values stay undefined forever.
//
// NEVER put an actual secret behind this — no API key, no password, no token, no
// webhook secret. OAuth client ids and the Turnstile SITE key are fine here (they're
// meant to be public), but REACT_APP_SECRET_KEY is a separate, pre-existing issue:
// it's a CRA build-time env var baked directly into the JS bundle by webpack —
// already exposed regardless of this file, and out of scope for this env.js change.
// ─────────────────────────────────────────────────────────────────────────────
export const NON_SECRET_OBFUSCATION_KEY_B64 = '/zN0bqEdGq7j6YtluzBAlL0HMt5n5zLDRBzKRJEcEjY='
